import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import PinPad from "@/components/PinPad";
import api from "@/lib/api";
import { toast } from "sonner";
import { ArrowLeft } from "@phosphor-icons/react";

export default function StaffLogin() {
    const nav = useNavigate();
    const [pin, setPin] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async () => {
        if (pin.length < 3) {
            toast.error("PIN must be at least 3 digits");
            return;
        }
        setLoading(true);
        try {
            const { data } = await api.post("/staff/login", { pin });
            localStorage.setItem("staff_token", data.token);
            localStorage.setItem("staff_name", data.staff.name);
            toast.success(`Welcome, ${data.staff.name}`);
            nav("/staff");
        } catch (e) {
            toast.error(e?.response?.data?.detail || "Invalid PIN");
            setPin("");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-bone text-ink flex flex-col">
            <div className="p-6 md:p-10 flex items-center justify-between">
                <Link to="/" className="inline-flex items-center gap-2 text-sm text-ash hover:text-ink" data-testid="staff-back-home">
                    <ArrowLeft size={16} /> Back
                </Link>
                <div className="text-xs uppercase tracking-[0.25em] text-ash">Staff Access</div>
            </div>

            <div className="flex-1 flex items-center justify-center px-6 pb-16">
                <div className="w-full max-w-md">
                    <div className="text-center mb-10 animate-fade-up">
                        <p className="text-xs uppercase tracking-[0.25em] text-ash mb-4">Noble Accounting Services</p>
                        <h1 className="font-serif text-5xl font-light mb-3">Enter your PIN.</h1>
                        <p className="text-ash text-sm">Default seed PIN is <span className="font-mono">786786</span> — change it in dashboard.</p>
                    </div>
                    <PinPad value={pin} onChange={setPin} onSubmit={submit} maxLength={6} />
                    <button
                        onClick={submit}
                        disabled={loading || pin.length < 3}
                        className="mt-8 w-full bg-moss text-bone py-4 text-sm uppercase tracking-[0.2em] hover:bg-moss-hover transition-colors disabled:opacity-40"
                        data-testid="staff-login-submit"
                    >
                        {loading ? "Signing in…" : "Sign in"}
                    </button>
                </div>
            </div>
        </div>
    );
}
